export enum Operators {
  OR = 'or',
  AND = 'and'
}